"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarCancellationPolarAnswerWidget = void 0;
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var React = require("react");
var services_1 = require("@falcon/services");
var core_1 = require("@athena-portal/core");
var react_router_dom_1 = require("react-router-dom");
var CarCancellationPolarAnswerWidget = exports.CarCancellationPolarAnswerWidget = /** @class */ (function (_super) {
    __extends(CarCancellationPolarAnswerWidget, _super);
    function CarCancellationPolarAnswerWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnChangeEvent = function (event) {
            if (event.target.value === "true") {
                _this.setState({
                    nextPageUrl: "/journey/show/product/MotorInsurance/process/mtcRemoveCar/presetPage/".concat(_this.props.engine.getInteraction()._id),
                    isCancellation: true
                });
            }
            else {
                _this.setState({
                    nextPageUrl: "/dashboard/yourCars",
                    isCancellation: false
                });
            }
        };
        _this.state = {
            nextPageUrl: "",
            carToCancel: null,
            isCancellation: null
        };
        return _this;
    }
    CarCancellationPolarAnswerWidget.prototype.componentDidMount = function () {
        var _this = this;
        this.customerPortalService.getPolicy(this.props.engine.getInteraction().agreementNumber).subscribe(function (policy) {
            _this.setState({
                carToCancel: policy.insuredVehicles[0]
            });
        });
    };
    CarCancellationPolarAnswerWidget.prototype.render = function () {
        var vehicleWording;
        if (this.state.carToCancel) {
            vehicleWording = this.state.carToCancel.make + " "
                + this.state.carToCancel.model + " (" + this.state.carToCancel.registrationNumber + ")";
        }
        else {
            vehicleWording = "your already covered vehicle";
        }
        return (React.createElement("div", { className: "w-100" },
            React.createElement("div", { className: "panel form-group p-4" },
                React.createElement("label", null,
                    "Do you need to cancel ",
                    vehicleWording,
                    " cover?"),
                React.createElement("div", { className: "input-group" },
                    React.createElement("div", { className: "custom-control custom-radio" },
                        React.createElement("input", { id: "".concat(this.props.question.name, "-true"), className: "custom-control-input null", type: "radio", name: "".concat(this.props.question.name, "-true"), value: "true", checked: this.state.isCancellation === true, onChange: this.handleOnChangeEvent }),
                        React.createElement("label", { className: "custom-control-label", htmlFor: "".concat(this.props.question.name, "-true") }, "Yes")),
                    React.createElement("div", { className: "custom-control custom-radio" },
                        React.createElement("input", { id: "".concat(this.props.question.name, "-false"), className: "custom-control-input null", type: "radio", name: "".concat(this.props.question.name, "-false"), value: "false", checked: this.state.isCancellation === false, onChange: this.handleOnChangeEvent }),
                        React.createElement("label", { className: "custom-control-label", htmlFor: "".concat(this.props.question.name, "-false") }, "No")))),
            React.createElement("div", { className: "form-group" },
                React.createElement(react_router_dom_1.Link, { to: this.state.nextPageUrl, className: "buttonLink", id: "nextLink" },
                    React.createElement("button", { type: "button", className: this.state.nextPageUrl === "" ? "btn btn-disabled-dashboard m-auto float-right" : "btn btn-default btn-primary btn-next m-auto float-right", id: "nextButton" }, "Next")))));
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], CarCancellationPolarAnswerWidget.prototype, "customerPortalService", void 0);
    return CarCancellationPolarAnswerWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=CarCancellationPolarAnswerWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/motor/CarCancellationPolarAnswerWidget.js
// module id = 3162
// module chunks = 0